import React, { useContext, useEffect, useState } from "react";
import "./myPatientsViewMainContent.scss";
import MyPatientsViewTableCell from "./MyPatientsViewTableCell";
import MyPatientsViewTableFooter from "./MyPatientsViewTableFooter";
import MyPatientsViewTableHeader from "./MyPatientsViewTableHeader";
import {
  API_FILTER_LIST,
  CONSULTATION_FILTER,
  DEFAULT_MYPATIENTS_PAYLOAD,
  MYPATIENTS_APPOINTMENTS_HEADER,
  SELECTED_FILTER_TITLE,
} from "../constants";
import NoDataComponent from "../../common/NoDataUI/NoDataComponent";
import Loader from "../../UI Component/Loader/Loader";
import NoDataFound from "../../../assets/Nodata.svg";
import Filter from "../../../assets/funnel.svg";
import CustomisedChip from "../../common/Modules/CustomisedChip";
import { ClickAwayListener } from "@material-ui/core";
import FilterMenuList from "../../common/Modules/FilterMenuList";
import {
  APPLICABLE_ROLE,
  dateFilter,
  getDateByRanges,
  HEADERLIST,
  HEADER_FILTER_TYPE,
  SELECTEDFILTERTITLE,
} from "../../DashboardAppointmentsView/Constant";
import DatePicker from "../../common/Modules/DatePicker";
import DoctorContext from "../../ClinicComponents/ClinicWrapper/DoctorContext";
import { GET_ALL_PROCEDURES_API } from "../MyPatientsViewAppointmentsApiHandler/apiConstants";
import {
  getMyPatientsAppointments,
  getProcedureForConsultationFilter,
} from "../MyPatientsViewAppointmentsApiHandler";
import moment from "moment";
import MobileFilterWithDatePicker from "../../common/Modules/MobileFilterWithDatePicker";
import { DateRangePicker } from "react-date-range";
import {
  GET_ALL_APPOINTMENTS_API,
  GET_CHECKED_IN_APPOINTMENT_API,
} from "../../DashboardAppointmentsView/DashboardAppointmentsViewApiHandler/APIConstants";
import {
  addQueryForMyPatient,
  getModifiedFilters,
  removeQueryForMyPatient,
} from "../helper";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../Util/constants";
import { c2cPostApiHandler } from "../../../Util/c2cApiHandler";
import { useHistory, useLocation } from "react-router-dom";

const MyPatientsViewMainContent = (props) => {
  const { patient_account_id, getPatientInfo } = props;

  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const doctor_context = useContext(DoctorContext);

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    dateDisplayFormat: "DD MMM YYYY",
    rangeColors: "#F969A4",
    color: "#F969A4",
    key: "selection",
  });
  const [appointmentsData, setAppointmentsData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecordsCount, setTotalRecordsCount] = useState(0);
  const [patientHeaderList, setPatientHeaderList] = useState(
    MYPATIENTS_APPOINTMENTS_HEADER
  );
  const [selected_header_item, setSelectedHeaderItem] = useState(null);
  const [applicableHeaderList, setApplicableHeaderList] = useState([]);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [consultationList, setConsultationList] = useState([]);
  const [doctor_selected, setDoctorSelected] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [procedureList, setProcedureList] = useState([]);
  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const [consultationType, setConsultationType] = useState("");
  const [procedureType, setProcedureType] = useState("");
  const [consultationTypeValue, setConsultationTypeValue] = useState("");
  const [procedureTypeValue, setProcedureTypeValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [checkedInAppnt, setCheckedInAppnt] = useState([]);
  const [showModalForScheduleFollowUp, setShowModalForScheduleFollowUp] =
    React.useState(false);
  const location = useLocation();
  const history = useHistory();
  const start_date = new URLSearchParams(location.search).get(
    API_FILTER_LIST.STARTDATE
  );
  const end_date = new URLSearchParams(location.search).get(
    API_FILTER_LIST.ENDDATE
  );
  const procedure = new URLSearchParams(location.search).get(
    API_FILTER_LIST.PROCEDURE
  );
  const procedure_name = new URLSearchParams(location.search).get(
    "procedure_name"
  );
  const status = new URLSearchParams(location.search).get("status_filter");
  const doctor_name = new URLSearchParams(location.search).get(
    API_FILTER_LIST.DOCTOR_NAME
  );
  const doctor_id = new URLSearchParams(location.search).get(
    API_FILTER_LIST.DOCTORNAME
  );
  const consultation_type = new URLSearchParams(location.search).get(
    API_FILTER_LIST.CONSULTATION
  );
  const consultation_name = new URLSearchParams(location.search).get(
    "consultation_name"
  );
  const completeParams = location.search;

  // Lifecycle Methods ===>

  useEffect(() => {
    if (userType !== APPLICABLE_ROLE.STAFF) {
      if (
        !doctorRole ||
        doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
        doctorRole === USER_ROLE.RESOURCE_CONSULTANT
      ) {
        if (start_date && end_date) {
          setStartDate(start_date);
          setEndDate(end_date);
        } else if (status) {
          setStatusFilter(status);
        } else if (doctor_id) {
          setSelectedDoctorId(doctor_id);
        } else if (procedure) {
          setConsultationType("");
          setProcedureType(procedure_name);
          setConsultationTypeValue("");
          setProcedureTypeValue(procedure);
        } else if (consultation_type) {
          setConsultationType(consultation_name);
          setProcedureType("");
          setConsultationTypeValue(consultation_type);
          setProcedureTypeValue("");
        }
        let filter_value = {
          [API_FILTER_LIST.CONSULTATION]: "",
          [API_FILTER_LIST.STARTDATE]: start_date ? start_date : "",
          [API_FILTER_LIST.ENDDATE]: end_date ? end_date : "",
          [API_FILTER_LIST.STATUS]: status,
          [API_FILTER_LIST.DOCTORNAME]: doctor_id ? doctor_id : "",
          [API_FILTER_LIST.CONSULTATION]: consultation_type
            ? consultation_type
            : "",
          [API_FILTER_LIST.PROCEDURE]: procedure ? procedure : "",
          [API_FILTER_LIST.PAGENO]: DEFAULT_MYPATIENTS_PAYLOAD.page_no,
        };
        getMyPatients(filter_value);
        handleFilterChip();
        getConsultationTypeProceduresAPI();
      }
    }
  }, [completeParams]);

  useEffect(() => {
    let arr = [],
      arr1 = [];
    doctor_context.selectedDoctor.length > 0 &&
      doctor_context.selectedDoctor.forEach((data) => {
        if (data?.selected === true) {
          arr.push(data.doctor_id);
          arr1.push(data);
        }
      });
    setDoctorSelected(arr);
    setDoctorList(arr1);
  }, [doctor_context.selectedDoctor]);

  useEffect(() => {
    if (
      doctor_selected.length > 0 &&
      (userType === APPLICABLE_ROLE.STAFF ||
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN)
    ) {
      if (start_date && end_date) {
        setStartDate(start_date);
        setEndDate(end_date);
      } else if (status) {
        setStatusFilter(status);
      } else if (doctor_id) {
        setSelectedDoctorId(doctor_id);
      } else if (procedure) {
        setConsultationType("");
        setProcedureType(procedure_name);
        setConsultationTypeValue("");
        setProcedureTypeValue(procedure);
      } else if (consultation_type) {
        setConsultationType(consultation_name);
        setProcedureType("");
        setConsultationTypeValue(consultation_type);
        setProcedureTypeValue("");
      }
      let filter_value = {
        [API_FILTER_LIST.CONSULTATION]: "",
        [API_FILTER_LIST.STARTDATE]: start_date ? start_date : "",
        [API_FILTER_LIST.ENDDATE]: end_date ? end_date : "",
        [API_FILTER_LIST.STATUS]: status,
        [API_FILTER_LIST.DOCTORNAME]: doctor_id ? doctor_id : "",
        [API_FILTER_LIST.CONSULTATION]: consultation_type
          ? consultation_type
          : "",
        [API_FILTER_LIST.PROCEDURE]: procedure ? procedure : "",
        [API_FILTER_LIST.PAGENO]: DEFAULT_MYPATIENTS_PAYLOAD.page_no,
      };
      getMyPatients(filter_value);
      handleFilterChip();
      getConsultationTypeProceduresAPI();
    } // with doctor ids itself getting called twice for admin doc
  }, [doctor_selected, completeParams]);

  useEffect(() => {
    let arr = [];
    if (doctorList) {
      arr.push({
        name: "All",
        value: "all",
        selected:
          !selectedDoctorId || selectedDoctorId.toLowerCase() === "all"
            ? true
            : false,
      });
      doctorList.forEach((doc) => {
        arr.push({
          ...doc,
          doctor_name: doc.prefix_name
            ? doc.doctor_name.replace(
                doc.prefix_name + (+doc.account_type === 1 ? " " : ""),
                +doc.account_type === 1 ? "" : doc.prefix_name + ". "
              )
            : doc.doctor_name,
          name: doc.prefix_name
            ? doc.name.replace(
                doc.prefix_name + (+doc.account_type === 1 ? " " : ""),
                +doc.account_type === 1 ? "" : doc.prefix_name + ". "
              )
            : doc.name,
          selected:
            selectedDoctorId && selectedDoctorId === doc.doctor_id
              ? true
              : false,
        });
      });
      patientHeaderList.forEach((hl) => {
        if (hl.title === HEADERLIST.DOCTORNAME) {
          hl.menuData = arr;
          hl.show_filter = false;
        } else {
          if (hl.show_filter) {
            hl.show_filter = false;
          }
        }
      });
      setPatientHeaderList([...patientHeaderList]);
    }
  }, [doctorList, selectedDoctorId]);

  useEffect(() => {
    patientHeaderList.forEach((list) => {
      if (list.title === HEADERLIST.CONSULTATION) {
        list.menuData = getConsultationMenu();
      }
    });
    setPatientHeaderList([...patientHeaderList]);
  }, [procedureList, consultationTypeValue, procedureTypeValue]);

  useEffect(() => {
    let selectedFilter = statusFilter
      ? statusFilter
      : DEFAULT_MYPATIENTS_PAYLOAD.status_filter;
    patientHeaderList.forEach((list) => {
      if (list.title === HEADERLIST.STATUS) {
        list.menuData.map(
          (menu) =>
            (menu.selected = menu.value === selectedFilter ? true : false)
        );
      }
    });
    setPatientHeaderList([...patientHeaderList]);
  }, [statusFilter]);

  // <===

  // Api Calls ===>

  const getConsultationTypeProceduresAPI = (id) => {
    let reqPayload = {
      clinic_id: clinicId,
    };
    if (
      doctorRole === USER_ROLE.DOCTOR_ADMIN ||
      doctorRole === USER_ROLE.RESOURCE_ADMIN ||
      userType === APPLICABLE_ROLE.STAFF
    ) {
      reqPayload["doctor_ids"] = id ? [id] : doctor_selected;
    } else {
      reqPayload["doctor_ids"] = [userId];
    }
    const consultationTypeResponse = getProcedureForConsultationFilter(
      reqPayload,
      GET_ALL_PROCEDURES_API
    );
    consultationTypeResponse.then(([res, error]) => {
      if (!error) {
        if (res) {
          setProcedureList(res);
        }
      }
    });
  };

  const getMyPatients = (data) => {
    let ids = getDoctorIds(data, true);
    let filterPayload = getFilterPayload(data);
    let reqPayload = {
      ...filterPayload,
      ...ids,
      clinic_id: clinicId,
      patient_account_id: patient_account_id,
      appointment_date: moment().format("YYYY-MM-DD"),
    };
    setLoader(true);
    const resData = getMyPatientsAppointments(
      reqPayload,
      GET_ALL_APPOINTMENTS_API
    ); //Fetch API Data
    resData.then(([res, error]) => {
      if (!error) {
        if (res) {
          setAppointmentsData(res.data);
          setPageNo(res.current_page);
          setTotalRecordsCount(+res.total_rows_count);
        } else {
          setAppointmentsData([]);
        }
      } else {
        setAppointmentsData([]);
      }
      setLoader(false);
    });

    let docIds = getDoctorIds(data, false);
    let payload = {
      doctor_ids: docIds?.doctor_ids,
      clinic_id: clinicId,
    };
    getCheckedInApi(payload);
  };

  const getCheckedInApi = (reqPayload) => {
    const resData = c2cPostApiHandler(
      GET_CHECKED_IN_APPOINTMENT_API,
      reqPayload
    );
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setCheckedInAppnt(res?.data?.checked_in_appt_doctor_ids);
        }
      }
    });
  };

  // <===

  // Helper methods ==>

  const getConsultationMenu = () => {
    let arr = [],
      list = [];
    let selectedFilter = consultationTypeValue
      ? consultationTypeValue
      : procedureTypeValue
      ? procedureTypeValue
      : "all";

    if (doctorRole?.includes("resource")) {
      list.push(CONSULTATION_FILTER[0], ...procedureList);
    } else {
      list.push(...CONSULTATION_FILTER, ...procedureList);
    }
    list.forEach((item) => {
      arr.push({
        ...item,
        selected:
          selectedFilter.toLowerCase() === item.value.toLowerCase()
            ? true
            : false,
      });
    });

    return arr;
  };

  const setFilters = (item) => {
    let val = selected_header_item;
    if (val.title === HEADERLIST.CONSULTATION) {
      if (item.type === "procedure") {
        addQueryForMyPatient(
          history,
          location,
          [
            API_FILTER_LIST.CONSULTATION,
            "consultation_name",
            API_FILTER_LIST.PROCEDURE,
            "procedure_name",
          ],
          ["", "", item.value ? item.value : "", item.name]
        );
      } else {
        addQueryForMyPatient(
          history,
          location,
          [
            API_FILTER_LIST.CONSULTATION,
            "consultation_name",
            API_FILTER_LIST.PROCEDURE,
            "procedure_name",
          ],
          [item.name, item.value, "", ""]
        );
      }
    } else if (val.title === HEADERLIST.DOCTORNAME) {
      addQueryForMyPatient(
        history,
        location,
        [API_FILTER_LIST.DOCTORNAME, API_FILTER_LIST.DOCTOR_NAME],
        [
          item.doctor_id ? item.doctor_id : "",
          item.doctor_name ? item.doctor_name : "",
        ]
      );
      getConsultationTypeProceduresAPI(item.doctor_id);
    } else if (val.title === HEADERLIST.STATUS) {
      addQueryForMyPatient(
        history,
        location,
        [API_FILTER_LIST.STATUS],
        [item.value]
      );
    } else if (val.title === HEADERLIST.DATETIME) {
      addQueryForMyPatient(
        history,
        location,
        [API_FILTER_LIST.STARTDATE, API_FILTER_LIST.ENDDATE],
        [item[0], item[1]]
      );
    }

    setPageNo(DEFAULT_MYPATIENTS_PAYLOAD.page_no);
  };

  const getIds = (data, doctor_filter) => {
    let ids = doctor_selected;
    let selectedId = selectedDoctorId ? [selectedDoctorId] : doctor_selected;
    if (data?.doctor_ids !== "") {
      ids = data?.doctor_ids
        ? [data?.doctor_ids]
        : doctor_filter
        ? selectedId
        : doctor_selected;
    }

    return ids;
  };

  const getDoctorIds = (data, doctor_filter) => {
    let doc_ids = { doctor_ids: [userId] };
    let dIds = getIds(data, doctor_filter);
    if (userType === APPLICABLE_ROLE.STAFF) {
      doc_ids.doctor_ids = dIds ? dIds : doctor_selected;
    } else if (clinicId) {
      if (
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN
      ) {
        let ids = doctor_selected?.length > 0 ? doctor_selected : doc_ids;
        doc_ids.doctor_ids = dIds ? dIds : ids;
      }
    }

    return doc_ids;
  };

  const getFilterPayload = (data) => {
    return {
      page_no: data?.page_no ? data?.page_no : pageNo,
      rows_per_page: DEFAULT_MYPATIENTS_PAYLOAD.rows_per_page,
      procedure_filter:
        data?.procedure_filter || data?.procedure_filter === ""
          ? data?.procedure_filter
          : procedureTypeValue,
      consultation_filter:
        data?.consultation_filter || data?.consultation_filter === ""
          ? getModifiedFilters(data?.consultation_filter)
          : getModifiedFilters(consultationType),
      status_filter:
        data?.status_filter || data?.status_filter === ""
          ? getModifiedFilters(data?.status_filter)
          : getModifiedFilters(statusFilter),
      start_date:
        data?.start_date || data?.start_date === ""
          ? data?.start_date
          : startDate,
      end_date:
        data?.end_date || data?.end_date === "" ? data?.end_date : endDate,
    };
  };

  const handleFilterChip = () => {
    let arr = [];
    let params = location.search?.replace("?", "");
    if (params) {
      let params_arr = params?.split("&");
      params_arr.forEach((pa) => {
        let param = pa?.split("=")[0];

        if (param === API_FILTER_LIST.STARTDATE) {
          arr.push({
            id: API_FILTER_LIST.DOCTORNAME,
            label:
              SELECTED_FILTER_TITLE.DATE +
              ": " +
              start_date +
              (start_date !== end_date ? " to " + end_date : ""),
          });
        } else if (param === API_FILTER_LIST.STATUS) {
          arr.push({
            id: API_FILTER_LIST.STATUS,
            label: SELECTED_FILTER_TITLE.STATUS + ": " + status,
          });
        } else if (param === API_FILTER_LIST.DOCTORNAME) {
          arr.push({
            id: API_FILTER_LIST.DOCTOR_NAME,
            label: SELECTED_FILTER_TITLE.DOCTORNAME + ": " + doctor_name,
          });
        } else if (param === API_FILTER_LIST.PROCEDURE && procedure) {
          arr.push({
            id: API_FILTER_LIST.PROCEDURE,
            label: SELECTED_FILTER_TITLE.CONSULTATION + ": " + procedure,
          });
        } else if (
          param === API_FILTER_LIST.CONSULTATION &&
          consultation_type
        ) {
          arr.push({
            id: API_FILTER_LIST.CONSULTATION,
            label:
              SELECTED_FILTER_TITLE.CONSULTATION + ": " + consultation_type,
          });
        }
      });
    }
    setSelectedFilters(arr);
  };

  // <===

  // Actions ==>

  const onPageChange = (val) => {
    setPageNo(val);
    getMyPatients({ [API_FILTER_LIST.PAGENO]: val });
  };

  const openMenuList = (val) => {
    let index = patientHeaderList.findIndex((list) => list.id === val.id);
    if (val.filter_type === HEADER_FILTER_TYPE.CONSULTATION) {
      setConsultationList(patientHeaderList[index].menuData);
    }
    patientHeaderList[index].show_filter =
      !patientHeaderList[index].show_filter;

    setPatientHeaderList([...patientHeaderList]);
    setSelectedHeaderItem(val);
  };

  const handleChipDelete = (id) => {
    let arr = selectedFilters;
    switch (id) {
      case API_FILTER_LIST.CONSULTATION:
        let ind = arr.findIndex((ar) => ar.id === API_FILTER_LIST.CONSULTATION);
        arr.splice(ind, 1);
        setConsultationType(DEFAULT_MYPATIENTS_PAYLOAD.consultation_filter);
        setProcedureType(DEFAULT_MYPATIENTS_PAYLOAD.procedure_filter);
        setConsultationTypeValue(
          DEFAULT_MYPATIENTS_PAYLOAD.consultation_filter
        );
        setProcedureTypeValue(DEFAULT_MYPATIENTS_PAYLOAD.procedure_filter);
        removeQueryForMyPatient(history, location, [
          API_FILTER_LIST.PROCEDURE,
          API_FILTER_LIST.CONSULTATION,
          "procedure_name",
          "consultation_name",
        ]);
        break;
      case API_FILTER_LIST.STATUS:
        let ind1 = arr.findIndex((ar) => ar.id === API_FILTER_LIST.STATUS);
        arr.splice(ind1, 1);
        setStatusFilter(DEFAULT_MYPATIENTS_PAYLOAD.status_filter);
        removeQueryForMyPatient(history, location, [API_FILTER_LIST.STATUS]);
        break;
      case API_FILTER_LIST.DOCTOR_NAME:
        let ind2 = arr.findIndex((ar) => ar.id === API_FILTER_LIST.DOCTOR_NAME);
        arr.splice(ind2, 1);
        setSelectedDoctorId(null);
        removeQueryForMyPatient(history, location, [
          API_FILTER_LIST.DOCTORNAME,
          API_FILTER_LIST.DOCTOR_NAME,
        ]);
        break;
      case API_FILTER_LIST.STARTDATE:
        let ind3 = arr.findIndex((ar) => ar.id === API_FILTER_LIST.STARTDATE);
        arr.splice(ind3, 1);
        setStartDate(DEFAULT_MYPATIENTS_PAYLOAD.start_date);
        setEndDate(DEFAULT_MYPATIENTS_PAYLOAD.end_date);
        removeQueryForMyPatient(history, location, [
          API_FILTER_LIST.STARTDATE,
          API_FILTER_LIST.ENDDATE,
        ]);
        break;
      default:
        break;
    }

    setPageNo(DEFAULT_MYPATIENTS_PAYLOAD.page_no);
    setSelectedFilters(arr);
  };

  const clearAllFilters = () => {
    setConsultationType(DEFAULT_MYPATIENTS_PAYLOAD.consultation_filter);
    setProcedureType(DEFAULT_MYPATIENTS_PAYLOAD.procedure_filter);
    setConsultationTypeValue(DEFAULT_MYPATIENTS_PAYLOAD.consultation_filter);
    setProcedureTypeValue(DEFAULT_MYPATIENTS_PAYLOAD.procedure_filter);
    setStatusFilter(DEFAULT_MYPATIENTS_PAYLOAD.status_filter);
    setSelectedDoctorId(null);
    setStartDate(DEFAULT_MYPATIENTS_PAYLOAD.start_date);
    setEndDate(DEFAULT_MYPATIENTS_PAYLOAD.end_date);
    setPageNo(DEFAULT_MYPATIENTS_PAYLOAD.page_no);
    setSelectedFilters([]);
    removeQueryForMyPatient(history, location, [
      API_FILTER_LIST.STARTDATE,
      API_FILTER_LIST.ENDDATE,
      API_FILTER_LIST.DOCTORNAME,
      API_FILTER_LIST.DOCTOR_NAME,
      API_FILTER_LIST.PROCEDURE,
      API_FILTER_LIST.CONSULTATION,
      API_FILTER_LIST.STATUS,
      "procedure_name",
      "consultation_name",
    ]);
  };

  const handleClose = (item) => {
    let index = patientHeaderList.findIndex((list) => list.id === item.id);
    patientHeaderList[index].show_filter = false;
    setPatientHeaderList([...patientHeaderList]);
  };

  const handleMobileSelectedItem = (val) => {
    setSelectedHeaderItem(val);
  };

  const toggleItems = (item) => {
    let val = selected_header_item;
    let index = patientHeaderList.findIndex((list) => list.id === val.id);
    patientHeaderList[index].show_filter = false;
    let index1 = patientHeaderList[index].menuData.indexOf(item);
    patientHeaderList[index].menuData.map((data) => (data.selected = false));
    patientHeaderList[index].menuData[index1].selected = true;
    setPatientHeaderList([...patientHeaderList]);
    setFilters(item);
  };

  const handleFilterSearch = (value) => {
    let index = patientHeaderList.findIndex(
      (list) => list.id === selected_header_item.id
    );

    if (
      patientHeaderList[index].filter_type === HEADER_FILTER_TYPE.CONSULTATION
    ) {
      const filterData = consultationList.filter((data) =>
        data?.name?.toLowerCase().includes(value?.toLowerCase())
      );
      patientHeaderList[index].menuData = filterData;
      setPatientHeaderList([...patientHeaderList]);
    }
  };

  const closeDatePicker = () => {
    patientHeaderList.forEach((hl) => {
      if (hl.title === HEADERLIST.DATETIME) {
        hl.show_filter = false;
      }
    });
    setPatientHeaderList([...patientHeaderList]);
  };

  const applyRange = (range) => {
    setFilters([
      moment(range.startDate).format("YYYY-MM-DD"),
      moment(range.endDate).format("YYYY-MM-DD"),
    ]);
    closeDatePicker();
  };

  const handleMobileFilter = () => {
    setShowMobileFilter(true);
    let list = [];
    patientHeaderList.forEach((menu) => {
      if (menu.filter_icon) {
        if (menu.title === HEADERLIST.DOCTORNAME) {
          if (
            doctorRole === USER_ROLE.DOCTOR_ADMIN ||
            doctorRole === USER_ROLE.RESOURCE_ADMIN ||
            userType === APPLICABLE_ROLE.STAFF
          ) {
            list.push(menu);
          }
        } else {
          list.push(menu);
        }
      }
    });
    list.forEach((li, ind) => {
      if (ind === list.length - 1) {
        li.show_filter = true;
        handleMobileSelectedItem(li);
      }
      if (li.mobileFilterTitle === HEADERLIST.MOBILEDATE) {
        li.menuData = dateFilter;
      }
      li.menuData &&
        li.menuData.forEach((menu, indM) => {
          menu.selected = indM === 0 ? true : false;
        });
    });
    setApplicableHeaderList([...list]);
  };

  const openMobileMenuList = (val) => {
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    applicableHeaderList.forEach((dh) => {
      dh.show_filter = false;
    });
    applicableHeaderList[index].show_filter = true;
    if (val.filter_type === HEADER_FILTER_TYPE.CONSULTATION) {
      setConsultationList(applicableHeaderList[index].menuData);
    }
    setApplicableHeaderList([...applicableHeaderList]);
    setSelectedHeaderItem(val);
  };

  const selectMobileFilterOptions = (item) => {
    let val = selected_header_item;
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    let index1 = applicableHeaderList[index].menuData.indexOf(item);
    applicableHeaderList[index].menuData.map((data) => (data.selected = false));
    applicableHeaderList[index].menuData[index1].selected = true;
    setApplicableHeaderList([...applicableHeaderList]);
  };

  const handleApplyFilter = (selectedValue) => {
    let val = selected_header_item;
    let index = applicableHeaderList.findIndex((list) => list.id === val.id);
    let item = applicableHeaderList[index].menuData.filter(
      (menu) => menu.selected
    );
    if (applicableHeaderList[index].title === HEADERLIST.DATETIME) {
      let range = {};
      if (selectedValue !== "Date Range") {
        range = getDateByRanges(selectedValue);
      } else {
        range = {
          startDate: moment(selectionRange.startDate).format("YYYY-MM-DD"),
          endDate: moment(selectionRange.endDate).format("YYYY-MM-DD"),
        };
      }
      setFilters([range.startDate, range.endDate]);
    } else {
      setFilters(item[0]);
    }
    handleCloseMobFilter();
  };

  const handleResetAllFilter = () => {
    handleCloseMobFilter();
    clearAllFilters();
  };

  const DateTimeRangeRender = () => {
    return (
      <DateRangePicker
        ranges={[selectionRange]}
        startDatePlaceholder="From"
        endDatePlaceholder="To"
        showSelectionPreview={true}
        editableDateInputs={true}
        showPreview={false}
        staticRanges={[]}
        inputRanges={[]}
        dragSelectionEnabled={true}
        onChange={(item) => handleSelect(item.selection)}
        maxDate={moment(new Date()).add(12, "months")._d}
        className="range-only-date m-auto"
      />
    );
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges);
  };

  const handleCloseMobFilter = () => {
    setShowMobileFilter(false);
    applicableHeaderList.forEach((list) => {
      list.show_filter = false;
      list.menuData.forEach((menu) => {
        menu.selected = false;
      });
    });
    setApplicableHeaderList([...applicableHeaderList]);
  };

  // <===

  // Display UI ===>

  const displayMyPatientsViewContent = () => {
    return (
      <div
        className="mypatients-view-main-content"
        style={{ height: window.innerWidth > 767 ? "calc(100vh - 110px)" : "" }}
      >
        {loader && <Loader />}
        <div className="d-flex ai-center">
          <div className="mypatients-view-main-content-title">
            My Appointments
          </div>
          {window.innerWidth < 767 && (
            <div
              onClick={handleMobileFilter}
              className="mypatients-view-mobile-filter"
            >
              <img src={Filter} alt="" />
            </div>
          )}
        </div>
        {window.innerWidth < 767 &&
          selectedFilters.length > 0 &&
          displaySelectedFilters()}
        <div className="mypatients-view-main-content-table">
          {window.innerWidth > 767 && displayMyPatientsViewTableHeader()}
          {appointmentsData?.length == 0
            ? displayNoDataFound()
            : displayMyPatientsViewTableContent()}
          {displayMyPatientsViewTableFooter()}
        </div>
        {showMobileFilter && (
          <MobileFilterWithDatePicker
            showMobileFilter={showMobileFilter}
            menuList={applicableHeaderList}
            selectedMenu={selected_header_item}
            handleClose={handleCloseMobFilter}
            openMobileMenuList={openMobileMenuList}
            handleMobileSelectedItem={handleMobileSelectedItem}
            selectMobileFilterOptions={selectMobileFilterOptions}
            handleApplyFilter={handleApplyFilter}
            handleResetAllFilter={handleResetAllFilter}
            handleFilterSearch={handleFilterSearch}
            DateTimeRangeRender={DateTimeRangeRender}
          />
        )}
      </div>
    );
  };

  const displayMyPatientsViewTableHeader = () => {
    return (
      <>
        <MyPatientsViewTableHeader
          headerList={patientHeaderList}
          doctorList={doctorList}
          openMenuList={openMenuList}
          displayNormalFilterList={displayNormalFilterList}
        />
        {selectedFilters?.length > 0 && displaySelectedFilters()}
      </>
    );
  };

  const displayMyPatientsViewTableContent = () => {
    let arr = patientHeaderList.map((item) => {
      return item["title"];
    });

    return (
      <MyPatientsViewTableCell
        appointmentsData={appointmentsData}
        arr={arr}
        user_type={userType}
        doctorRole={doctorRole}
        user_id={userId}
        clinic_id={clinicId}
        staff_id={staffId}
        page_no={pageNo}
        selected_doctor={doctorList}
        doctorClinicAssociation={doctorClinicAssociation}
        checkedInAppnt={checkedInAppnt}
        refreshAppointmentsMethod={getMyPatients}
        appointmentsApi={() => {
          getMyPatients();
          getPatientInfo();
        }}
        showModalForScheduleFollowUp={showModalForScheduleFollowUp}
        setShowModalForScheduleFollowUp={setShowModalForScheduleFollowUp}
        callNextAppointmentWidget={() => getPatientInfo()}
      />
    );
  };

  const displayMyPatientsViewTableFooter = () => {
    return (
      <MyPatientsViewTableFooter
        appointmentsData={appointmentsData}
        currentPage={pageNo}
        totalCount={totalRecordsCount}
        pageSize={Number(DEFAULT_MYPATIENTS_PAYLOAD.rows_per_page)}
        onPageChange={onPageChange}
      />
    );
  };

  const displayNoDataFound = () => {
    return (
      !loader && (
        <div style={{ padding: "20px 0" }}>
          <NoDataComponent
            image={NoDataFound}
            heading={"No Record Found"}
            message={"There are no appointments available"}
          />
        </div>
      )
    );
  };

  const displayNormalFilterList = (val) => {
    if (val.filter_type !== HEADER_FILTER_TYPE.DATE) {
      return (
        <ClickAwayListener onClickAway={() => handleClose(val)}>
          <div>
            <FilterMenuList
              menuItemList={val.menuData}
              toggleItems={toggleItems}
              handleFilterSearch={handleFilterSearch}
              show_filter_searchbar={val?.show_filter_searchbar}
              placeholderForSearch={val?.placeholderForSearch}
            />
          </div>
        </ClickAwayListener>
      );
    } else {
      return (
        <ClickAwayListener onClickAway={() => handleClose(val)}>
          <div>
            <DatePicker
              closeDatePicker={closeDatePicker}
              applyRange={applyRange}
              maxDate={moment(new Date()).add(12, "months")._d}
            />
          </div>
        </ClickAwayListener>
      );
    }
  };

  const displaySelectedFilters = () => {
    return (
      <div className="dashborad-appointments-filter-chips d-flex">
        {selectedFilters.map((sl, ind) => (
          <div className="deletable-chip" key={ind}>
            <CustomisedChip
              label={sl.label}
              id={sl.id}
              deletable={true}
              deleteHandler={handleChipDelete}
            />
          </div>
        ))}
        {selectedFilters.length > 0 && (
          <div className="clear-all-chip">
            <CustomisedChip
              label={SELECTEDFILTERTITLE.CLEARALL}
              id={SELECTEDFILTERTITLE.CLEARALL}
              clickHandler={clearAllFilters}
            />
          </div>
        )}
      </div>
    );
  };

  // <===

  return <>{displayMyPatientsViewContent()}</>;
};

export default MyPatientsViewMainContent;
